import { styled, ToggleButton, ToggleButtonGroup } from '@mui/material';

export const SwitcherGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    width: '100%',
    padding: '2px',
    gap: '2px',
    backgroundColor: theme.palette.backgrounds.heatmapTableBg,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '4px',
}));

export const SwitcherButton = styled(ToggleButton)(({ theme }) => ({
    flex: 1,
    padding: '4px 8px',
    fontSize: '12px',
    lineHeight: '16px',
    fontWeight: 400,
    textTransform: 'none',
    whiteSpace: 'nowrap',
    color: theme.palette.customText.text1,
    border: '1px solid transparent',
    borderRadius: '4px !important',

    '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.hyperLiquidColor2,
    },

    '&.Mui-selected, &.Mui-selected:hover': {
        fontWeight: 500,
        color: theme.palette.hyperLiquidColor2,
        backgroundColor: theme.palette.backgrounds.buttonSelectBg,
        border: `1px solid ${theme.palette.hyperLiquidColor}`,
    },
}));
